import { Layout, Typography, Result } from 'antd';
interface AccessBlockedScreenProps {}

const AccessBlockedScreen: React.FC<AccessBlockedScreenProps> = () => {
  return (
    <Layout
      style={{
        minHeight: '100vh',
        width: '100vw',
        overflowX: 'hidden',
        overflowY: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Result
        style={{
          boxShadow: '-2px 0 12px rgba(0, 0, 0, 0.2)',
          width: '80%',
          height: '80vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        status="error"
        title={<Typography.Title level={2}>No Access</Typography.Title>}
        subTitle={<Typography.Title level={2}>You don't have access to this page.</Typography.Title>}
      ></Result>
    </Layout>
  );
};

export default AccessBlockedScreen;
